import { Box, Tooltip } from '@mui/material';
import { LeadInfoDto, LeadSourceType } from '@sr/dto';

type Props = Pick<LeadInfoDto, 'sourceType' | 'sourceValue' | 'source2Name'>;

export const LeadSourceLabel = ({ sourceType, sourceValue, source2Name }: Props) => {
  const value = source2Name || sourceValue || '—';
  const emails = !source2Name && sourceType === LeadSourceType.EMAIL
    ? (sourceValue ?? '').split(',').map((email) => email.trim()).filter(Boolean)
    : [];
  const multipleEmails = emails.length > 1;
  const hint = source2Name ? `Источник определён правилом\n${value}` : multipleEmails ? emails.join('\n') : value;

  return (
    <Tooltip title={<Box sx={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{hint}</Box>}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, maxWidth: 320 }}>
        {source2Name && <Box component="span" aria-hidden="true" sx={{ width: 6, height: 6, border: '1px solid', borderColor: 'primary.main', transform: 'rotate(45deg)', flexShrink: 0, mx: 0.25 }} />}
        <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {multipleEmails ? emails[0] : value}
        </Box>
        {multipleEmails && <Box component="span" sx={{ flexShrink: 0, whiteSpace: 'nowrap', color: 'text.secondary' }}>ещё {emails.length - 1}</Box>}
      </Box>
    </Tooltip>
  );
};
